import React, { useState, useEffect, useRef, useCallback } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';
import { useDispatch, useSelector } from 'react-redux';
import { loading } from '../../actions';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Checkbox } from 'primereact/checkbox';
import { Fieldset } from 'primereact/fieldset';
import { ToggleButton } from 'primereact/togglebutton';
import { InputSwitch } from 'primereact/inputswitch';
import classNames from 'classnames';
import { getListaPerfil, getListaAccionesPerfil, asignarAccionesPerfil, crearPerfil, editarPerfil, eliminarPerfil } from '../../service/Perfil';
import { isNotVacioNull, isEmail, isRun, isLetras, isLetrasEspacio, minMax, isValue, isTelefono, getResultValidar } from '../../utilities/Validate'

import { useHistory } from 'react-router-dom';
import { accionPermiso } from '../../utilities/Seguridad'

export const PagePerfilAcceso = () => {

  let ColegioData = {
    "id": null,
    "idmatricula": null,
    "idalumno": null,
    "fecha_matricula": "",
    "rbd": "",
    "colegio": "",
    "grado": "",
    "run": "",
    "digito_verificador": "",
    "nombres": "",
    "apellido_paterno": "",
    "apellido_materno": "",
    "diagnostico": "",
    "tipo_nee": "",
    "observacion": "",
    "adicional": ''
  };

  let rol = {
    id: null,
    rol: '',
    estado: 0
  }

  let rolValidate = {
    id: { estado: null, mensaje: '', validar: isValue, minmax: false },
    rol: { estado: null, mensaje: 'Valor requerido letras con longitud max. 3', validar: isLetrasEspacio, minmax: true, min: 1, max: 20 },
    estado: { estado: null, mensaje: '', validar: isValue, minmax: false },
  }

  const [dataTable, setDataTable] = useState(ColegioData);
  const [globalFilter, setGlobalFilter] = useState('');
  const [selectedValue, setSelectedValue] = useState(null);
  const [arrayPermiso, setArrayPermiso] = useState({});
  const [visibleDialog, setVisibleDialog] = useState(false);
  const [dataAcciones, setDataAcciones] = useState([]);
  const [submitted, setSubmitted] = useState(false);

  const [rolData, setRolData] = useState(rol);
  const [rolDataValidate, setRolDataValidate] = useState(rolValidate);
  const [todosChecked, setTodosChecked] = useState(false);
  const toast = useRef(null);
  const labelDialog = useRef({ title: '', labelButton: '', editAcceso: {}, visible: false, es_nuevo: false });
  const iniLista = useRef(false);
  const roww = useRef(null);
  const dispatch = useDispatch();

  const history = useHistory();
  const permisos = useRef({ superusuario: false, acciones: [] });
  const { usuario, colegio, anio } = useSelector(state => ({
    usuario: state.usuario,
    colegio: state.colegio,
    anio: state.anio
  }));

  try {
    permisos.current.superusuario = usuario.superusuario;
    permisos.current.acciones = usuario.permisos.seguridad.roles.acciones;
  } catch (error) {
    permisos.current.acciones = []
  }

  const loadListaPerfil = async () => {

    if (colegio.id !== undefined) {
      dispatch(loading(true));
      var data = await getListaPerfil(usuario.token, colegio.id);
      if (data.error == 0) {
        setDataTable(data.roles)
      } else {
        if (data.error == 1) {
          toast.current.show({ severity: 'error', summary: 'Error', detail: data.mensaje, life: 3000 });
        } else {
          console.log('Error');
        }
      }

      dispatch(loading(false));

    }

  }


  useEffect(() => {
    iniLista.current = false;
  }, [dataAcciones]);

  useEffect(() => {

    if (accionPermiso(permisos, 'rol_ver')) {
      loadListaPerfil();
    } else {
      history.push('/Acceso')
    }

  }, [anio]);


  const getListaAcciones = async (row) => {

    if (colegio.id !== undefined) {
      dispatch(loading(true));
      //let idColegio = row.editable==1?row.idcolegio:colegio.id;
      var data = await getListaAccionesPerfil(row.id, permisos.current.superusuario ? 0 : row.idcolegio, usuario.token);
      if (data.error == 0) {
        iniLista.current = true;
        setDataAcciones(data.acciones);
      } else {
        if (data.error == 1) {
          toast.current.show({ severity: 'error', summary: 'Error', detail: data.mensaje, life: 3000 });
        } else {
          console.log('Error');
        }

      }

      dispatch(loading(false));

    }

  }

  const saveAccesoRol = async () => {

    if (colegio.id !== undefined) {
      dispatch(loading(true));
      let json = JSON.stringify(Object.values(arrayPermiso));
      var data = await asignarAccionesPerfil(selectedValue.id, json, usuario.token);
      if (data.error == 0) {

        getListaAcciones(selectedValue);
        toast.current.show({ severity: 'success', summary: 'OK', detail: "Registros guardados!", life: 3000 });

      } else {
        if (data.error == 1) {
          toast.current.show({ severity: 'error', summary: 'Error', detail: data.mensaje, life: 3000 });
        } else {
          console.log('Error');
        }

      }
      dispatch(loading(false));
    }
  }

  const savePerfil = async () => {

    setSubmitted(true);

    if (colegio.id !== undefined) {

      let validado = getResultValidar(rolData, rolDataValidate);

      setRolDataValidate(validado.result);

      if (validado.registra) {
        dispatch(loading(true));
        var data = null;

        if (labelDialog.current.es_nuevo) {
          data = await crearPerfil(rolData, colegio.id, usuario.token);
        } else {
          data = await editarPerfil(rolData, colegio.id, usuario.token);
        }

        if (data.error == 0) {

          hideDialog();
          loadListaPerfil();
          toast.current.show({ severity: 'success', summary: 'OK', detail: "Registros guardados!", life: 3000 });

        } else {
          if (data.error == 1) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: data.mensaje, life: 3000 });
          } else {
            console.log('Error');
          }

        }
        dispatch(loading(false));

      }

    }
  }

  const viewNuevoPerfilAcceso = () => {
    setVisibleDialog(true);
    labelDialog.current.title = 'Nuevo Perfil Acceso';
    labelDialog.current.labelButton = 'Registrar';
    labelDialog.current.es_nuevo = true;
    setRolData(rol);
  }


  const bodyTemplate = (data, props) => {
    return (
      <>
        <span className="p-column-title">{props.header}</span>
        {props.field === 'run' ? data['run'] + '-' + data['digito_verificador'] : data[props.field]}

      </>
    );
  };


  const dataTableHeader = (
    <div className="table-header">

      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Buscar..." />
      </span>


      <div className="flex align-items-center export-buttons" >
        {accionPermiso(permisos, 'rol_crear') ? <Button type="button" icon="pi pi-plus" className="mr-2 p-mr-1" onClick={viewNuevoPerfilAcceso} tooltip="Nuevo Perfil" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}></Button>
          : ''
        }
        <Button type="button" icon="pi pi-refresh" className="mr-2" onClick={loadListaPerfil} tooltip="Actualizar" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}></Button>
      </div>

    </div>
  );


  const viewDetalle = (row) => {

    labelDialog.current.visible = true;
    labelDialog.current.title = 'Actualizar Perfil Acceso';
    labelDialog.current.labelButton = 'Actualizar';
    labelDialog.current.es_nuevo = false;
    let dataEdit = { ...rol };
    dataEdit.rol = row.rol;
    dataEdit.id = row.id;
    dataEdit.estado = row.estado == 1 ? true : false;
    setVisibleDialog(true);
    setRolData(dataEdit);

  }

  const accept = async () => {

    let data = await eliminarPerfil(roww.current, colegio.id, usuario.token);
    if (data.error == 0) {
      toast.current.show({ severity: 'success', summary: 'OK', detail: "Se eliminó el perfil", life: 3000 });
      loadListaPerfil();

    } else {
      if (data.error == 1) {
        toast.current.show({ severity: 'error', summary: 'Error', detail: data.mensaje, life: 3000 });
      } else {
        console.log('Error');
      }
    }

  }


  const confirmDelete = (row) => {
    roww.current = row.id;
    confirmDialog({
      message: 'Estas seguro de eliminar el registro?',
      header: 'Eliminar Confirmar',
      icon: 'pi pi-info-circle',
      acceptClassName: 'p-button-danger',
      accept

    });
  };


  const actionBodyDelete = (rowData) => {
    return (
      <div className="actions">
        <Button icon="pi pi-trash" className="p-button-rounded p-button-warning" onClick={() => confirmDelete(rowData)} />
      </div>
    );
  }

  const sabePermisoCheck = (value, key) => {
    let permiso = { ...arrayPermiso };
    permiso[`${key}`].estado = value ? 1 : 0;
    setArrayPermiso(permiso);
  }

  const selectDataTableValue = async (value) => {

    if (labelDialog.current.visible) return;

    if (permisos.current.superusuario) {

      if (value !== null) {
        if (value.estado == 2) return;
      }

    } else {

      if (value !== null) {
        //if (value.editable == 0 || value.estado == 2) return;
        if ( value.estado == 2) return;
      }

      if (!accionPermiso(permisos, 'rol_ver_accion')) return;

    }

    setSelectedValue(value);
    labelDialog.current.editAcceso = value;
    setArrayPermiso({});
    setTodosChecked(false)
    setDataAcciones([]);
    if (value !== null) {
      getListaAcciones(value);
    }

  }

  const hideDialog = () => {
    setVisibleDialog(false);
    labelDialog.current.visible = false;
    setSubmitted(false);
    //setDataMatricula(null);
  }

  const dialogFooter = (
    <>
      <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
      <Button label={labelDialog.current.labelButton} icon="pi pi-check" onClick={savePerfil} />
    </>
  );

  const onInputChange = (e, name) => {

    const val = (e.target && e.target.value) || '';
    let _detalla = { ...rolData };
    _detalla[`${name}`] = val;
    setRolData(_detalla);
  }

  const actionBodyEdit = (rowData) => {

    return (
      <div className="actions">
        {accionPermiso(permisos, 'rol_editar') ?
          rowData.editable == 0 ? '' :
            <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-mr-2" onClick={() => viewDetalle(rowData)} />
          : ''
        }
        {accionPermiso(permisos, "rol_eliminar") ? rowData.editable == 0 ? '' : <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => confirmDelete(rowData)} /> : ""}
      </div>
    );
  }

  const bodyTemplateActivo = (data, props) => {
    return (
      <>
        <span className="p-column-title">{props.header}</span>
        <Tag className="p-mr-2" severity={data[props.field] == 1 ? 'success' : 'warning'} value={data[props.field] == 1 ? 'ACTIVO' : 'INACTIVO'}></Tag>

      </>
    );
  };


  const handleCheckboxChange = (checked) => {
    setTodosChecked(checked);
    let obj = { ...arrayPermiso }
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) { // Verificar si la propiedad pertenece directamente al objeto (no heredada)
        obj[key].estado = checked ? 1 : 0;;
      }
    }
    setArrayPermiso(obj)
  };


  return (

    <div className="p-grid table-demo p-col-12">

      <Toast ref={toast} />

      <div className="p-grid widgets">
        <div className="p-col-12 p-lg-4">
          <div className="card ">
            <DataTable value={dataTable} paginator id="16" selectionMode="single" metaKeySelection={false} rowsPerPageOptions={[5, 10, 25]} rows={10} className="p-datatable-customers p-datatable-sm" dataKey="id"
              rowHover selection={selectedValue} onSelectionChange={(e) => selectDataTableValue(e.value)} globalFilter={globalFilter} emptyMessage="No existe información!" loading={false} header={dataTableHeader} size="small">

              {/* <Column headerStyle={{ width: '4rem', textAlign: 'left' }} field="id" header="id" sortable body={bodyTemplate} ></Column> */}
              <Column field="rol" header="Perfil" sortable body={bodyTemplate} ></Column>
              <Column headerStyle={{ width: '6rem', textAlign: 'center' }} field="estado" header="Estado" sortable body={bodyTemplateActivo} ></Column>
              <Column header="Acción" headerStyle={{ width: '7rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible', justifyContent: 'center' }} body={actionBodyEdit}></Column>

            </DataTable>
          </div>
        </div>

        <div className="p-col-12 p-lg-8">
          <div className="card widget-statistics">
            <div className="p-grid">
              <div className="p-col-6">
                <div className="box"><h5>ACCESOS{labelDialog.current.editAcceso == null || labelDialog.current.editAcceso.rol == undefined ? '' : ' DE ' + labelDialog.current.editAcceso.rol}</h5></div>
              </div>

              {labelDialog.current.editAcceso == null || labelDialog.current.editAcceso.rol == undefined ? '' :
                <div className="p-col-3 p-offset-3" style={{ textAlign: 'right' }}>
                  <div className="box">
                    <div className="p-d-flex p-jc-between p-ai-center">
                      {((accionPermiso(permisos, 'rol_editar_accion') && labelDialog.current.editAcceso.editable===1) ||
                      permisos.current.superusuario) &&(
                        <div style={{ marginRight: '10px' }}>
                          <Checkbox inputId="checkboxTodos" onChange={(e) => handleCheckboxChange(e.checked)} checked={todosChecked} />
                          <label htmlFor="checkboxTodos" className="p-checkbox-label p-ml-1">Todos</label>
                        </div>
                      )}
                      {((accionPermiso(permisos, 'rol_editar_accion') && labelDialog.current.editAcceso.editable===1) ||
                      permisos.current.superusuario) && (
                        <div className="box">
                          <Button label='GUARDAR' icon="pi pi-check" onClick={saveAccesoRol} className="p-mr-2" />
                        </div>
                      )}
                    </div>
                  </div>
                </div>}

            </div>

            {
              dataAcciones?.map((menu, index1) => {

                return <Fieldset key={index1} legend={menu.menu.toUpperCase()} className="p-col-12 p-p-0 p-mb-2">
                  <div className="p-d-flex p-flex-wrap">
                    {menu.content?.map((conte, index2) => {
                      return <React.Fragment key={index2}>
                        <div className="p-mr-2 p-mb-2" style={{ padding: '5px', borderRadius: '5px', borderColor: 'rgb(173 175 178)', borderStyle: 'solid', borderWidth: '1px' }}>

                          <div className="p-p-0" style={{ fontWeight: 'normal', color: "var(--primary-color)" }}>{conte.sub_menu}</div>
                          {
                            conte.acciones?.map((accion, index3) => {
                              let key = index1.toString() + index2.toString() + index3.toString();
                              let array = { idacceso: accion.idacceso, idaccion: accion.idaccion, estado: accion.estado };
                              arrayPermiso[`${key}`] = (iniLista.current ? array : arrayPermiso[`${key}`]);
                              return <ToggleButton disabled={((accionPermiso(permisos, 'rol_editar_accion') && labelDialog.current.editAcceso.editable===1) || permisos.current.superusuario) ? false : true} key={index3} checked={arrayPermiso[`${key}`].estado}
                                onChange={(e) => sabePermisoCheck(e.value, key)} onLabel={accion.accion}
                                offLabel={accion.accion} onIcon="pi pi-check" offIcon="pi pi-times"
                                style={{
                                  height: '1.4em', background: "var(--primary-color)",
                                  opacity: arrayPermiso[`${key}`].estado ? '100%' : '50%'
                                }}
                                className="p-mr-1 p-mt-1" aria-label="Confirmation" />
                            })}
                        </div>
                      </React.Fragment>
                    })}

                  </div>
                </Fieldset>
              })}

          </div>
        </div>

      </div>

      <Dialog visible={visibleDialog} style={{ width: '40vw' }} breakpoints={{ '960px': '100vw' }} header={labelDialog.current.title} modal className="p-fluid" footer={dialogFooter} onHide={hideDialog}>

        <div className="p-grid flexgrid-demo">
          <div className="p-col-12 p-lg-12">
            <div className="p-grid p-lg-12">
              <div className="p-col-12 p-md-6 p-lg-8">

                <label htmlFor="name2">Nombre</label>
                <InputText id="name2" type="text" value={rolData.rol} onChange={(e) => onInputChange(e, 'rol')} required className={classNames({ 'p-invalid': submitted && !rolDataValidate.rol.estado })} />
                {submitted && !rolDataValidate.rol.estado && <small className="p-error">{rolDataValidate.rol.mensaje}</small>}

              </div>

              <div className="p-col-12 p-md-6 p-lg-4">
                <label htmlFor="name2">Estado</label>
                <div className="p-field-radiobutton p-mt-2 p-mb-1">
                  <InputSwitch name="Habilitado" checked={rolData.estado} onChange={(e) => onInputChange(e, 'estado')} />
                </div>
              </div>
            </div>
          </div>

        </div>
      </Dialog>

    </div>
  )

}